import BlogContainer from "../components/BlogContainer/BlogContainer";
import Sidebar from "../components/Sidebar/Sidebar";

export default function Home() {
  return (
    <section className="wrapper">
      <aside>
        <Sidebar />
      </aside>
      <BlogContainer />
    </section>
  );
}
